var DRAWING_ITEMS = 'drawingItems';
var DRAWING_ITEMS_VERSION = '1.1';
var DRAWING_ITEMS_VERSION_KEY = 'DRAWING_ITEMS_VERSION';
var DRAWING_ID = 'idGlobal';
var TREE_NODE_ID = 'treeNodeId';
var FORM_CONF = 'formConf';
export function getDrawingList() {
  // 加入缓存版本的概念，保证缓存数据与程序匹配
  var version = localStorage.getItem(DRAWING_ITEMS_VERSION_KEY);
  if (version !== DRAWING_ITEMS_VERSION) {
    localStorage.setItem(DRAWING_ITEMS_VERSION_KEY, DRAWING_ITEMS_VERSION);
    saveDrawingList([]);
    return null;
  }
  var str = localStorage.getItem(DRAWING_ITEMS);
  if (str) return JSON.parse(str);
  return null;
}
export function saveDrawingList(list) {
  localStorage.setItem(DRAWING_ITEMS, JSON.stringify(list));
}
export function getIdGlobal() {
  var str = localStorage.getItem(DRAWING_ID);
  if (str) return parseInt(str, 10);
  return 100;
}
export function saveIdGlobal(id) {
  localStorage.setItem(DRAWING_ID, "".concat(id));
}
export function getTreeNodeId() {
  var str = localStorage.getItem(TREE_NODE_ID);
  if (str) return parseInt(str, 10);
  return 100;
}
export function saveTreeNodeId(id) {
  localStorage.setItem(TREE_NODE_ID, "".concat(id));
}
export function getFormConf() {
  var str = localStorage.getItem(FORM_CONF);
  if (str) return JSON.parse(str);
  return null;
}
export function saveFormConf(obj) {
  localStorage.setItem(FORM_CONF, JSON.stringify(obj));
}

/**
 * 根据自己的需求获取配置的表单信息
 */
export function getFormConfSelf() {
  var formConfig = localStorage.getItem(FORM_CONF);
  formConfig = JSON.parse(formConfig);
  var formItemConfig = localStorage.getItem(DRAWING_ITEMS);
  if (!formConfig && !formItemConfig) return 'Error';
  formItemConfig = JSON.parse(formItemConfig);
  formConfig.fields = formItemConfig;
  return formConfig;
}